<template>
	<div id="container" style="    width: 100%;height:100%;		background-color: #f7f7f7;" @click="categoryPageClick">
		<a-spin :spinning="reloadSpinning">
			<div>
				<Font @setOffsetTop="setOffsetTop"></Font>
				<div :style="scrolldiv" @scroll="handleScroll" class="scrolldiv">
					<div class="catalog-article-detail" style="width:60%">
						<div class="detail">
							<div class="powerby">
								<img class="powerby-image"
									:src="!todayImg ? require('../../assets/title_logo.png') : todayImg" />
							</div>
							<div class="tabs" v-if="aiCategoryId!=null">


								<div @click="toTab(index)" v-for="(item,index) in tabs"
									:class="{item:true,selected:tab==index}" v-bind:key="index">
									<!-- <img :src="tabSrc" v-if="tab==index" /> -->
									<text>{{item}}</text>
									<!-- <div class="beta" v-if="index==0">beta</div> -->
								</div>


							</div>
							<template v-if="tab==0&&aiCategoryId!=null">
								<div v-html="aiContent" ref="htmlContainer" @click.stop="aiContentClick($event)"></div>
								<div @click.stop="clickLinkArticle" id="linkArticle"
									:style='{display:linkArticle.display,top:linkArticle.top,"z-index":linkArticle.index}'
									class="linkArticle">
									<div @click.stop="clickLinkArticleItem(item)"
										style="display: flex;    align-items: center;" v-for="(item,index) in linkList"
										v-bind:key="index">
										<div class="linkItem">{{item.index}}、{{item.title}}

										</div>
										<img :src="linkSrc" style="width: 15px;height: 15px;" />
									</div>

								</div>
							</template>

							<div v-else>
								<div
									:class="fontSize == 2 ? 'precontent' : fontSize == 1 ? 'precontent titleSmall' : 'precontent titleBig'">
									<text>今天情报强企为您定制化推送情报</text>
									<text class="precontent-blue">{{ precontent }}</text>
									<text>条，以下是速览列表，点击可浏览全文：</text>
								</div>
								<div style="padding: 32px;">
											<template v-for="(catalogItem,index) in catalogList" :id="catalogItem.articleCategoryId">
						<div class="catalog-card">

			
								<div  :style="{'position': 'sticky','z-index':index+10,top:0}">
									<div class="catalog-header" :style="{ zIndex: index+10 }"
									@click.stop="toCollapsed(catalogItem.articleCategoryId)">
									<div 
									:class="fontSize == 2 ? 'catalog-title' : fontSize == 1 ? 'catalog-title titleSmall' : 'catalog-title titleBig'"
									>{{catalogItem.articleCategory}}</div>
									<div class="catalog-info">
										<text class="article-count">{{catalogItem.total}}篇</text>
										<div
											:class="{'toggle-button':true,'iconClass':!isCollapsed(catalogItem.articleCategoryId)}">
											<DownOutlined v-if="isCollapsed(catalogItem.articleCategoryId)"/>
											<UpOutlined v-else />
										</div>
									</div>
								</div>
								</div>
							
							<div
								:class="{'catalog-content':true,'collapsed':isCollapsed(catalogItem.articleCategoryId)}">
								<template v-for="(item) in catalogItem.children" :id="item.key">
									<div  :class="fontSize == 2 ? 'article-title' : fontSize == 1 ? 'article-title titleSmall' : 'article-title titleBig'"
  			@click="clickAticle(item)">
										<div :class="item.secondaryArticleCategory ? 'inline-title1' : 'inline-title'">
											<div>
												<img class="inline-img" src="../../assets/dot-m.png">
											</div>
											<div class="inline-content ">
												<template v-if="item.titleList&&item.titleList.length>0">
													<a v-for="title,titleIndex in item.titleList"
														:class="item.read? 'article-title-off' : (titleIndex==0&&item.titleList.length>1?'article-title-name':'')">{{title}}</a>
												</template>
											</div>

										</div>
										<div :style="{'padding-bottom':item.secondaryArticleCategory?'0px':'24px'}">
											<div :class="fontSize == 2 ? 'introduce' : fontSize == 1 ? 'introduce introduceSmall' : 'introduce introduceBig'">
												{{item.introduction}}
											</div>
										</div>
										<div v-if="item.secondaryArticleCategory" :class="fontSize == 2 ? 'secondary' : fontSize == 1 ? 'secondary secondarySmall' : 'secondary secondaryBig'">
											<div class="bg-blue-category">
												<text class="text-s"> {{item.secondaryArticleCategory}}</text>
											</div>
										</div>
									</div>
								</template>

							</div>
						</div>
					</template>
				
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</a-spin>

	</div>
</template>
<script>



import $ from 'jquery'
import { UpOutlined,DownOutlined } from '@ant-design/icons-vue'
import Font from '../articleComponent/Font.vue'
import { toDoArticleRecord } from './js/index'
import { getLoginUserInfo } from '../../views/js/index'
import { useRouter } from 'vue-router';
import { guestArticle, readList } from '../articleComponent/js/index'
import { onMounted, watch, ref, onDeactivated, onActivated } from 'vue'
import store from '@/store';
import router from '@/router';
import { nextTick } from 'vue';
import { createTitle } from '@/untils';
export default {
	name: 'catalogArticleDetail',
	components: { Font,UpOutlined,DownOutlined  },

	setup() {
		watch(() => store.getters.fontSize, (val, oldVal) => {
			fontSize.value = val
			toGetResize(fontSize.value, oldVal, aiContent.value)
			
		})
		const $router = useRouter();
		watch(
			() => $router.currentRoute.value.query,
			(val,old) => {
				if ($router.currentRoute.value.path.indexOf('catalogArticleDetail') > -1 && val && val.carticleId) {

							if(!(old.articleId&&val.carticleId)){
				
								tab.value=0
								collapsedList.value=[]
					}
					articleId.value = val.carticleId

					aiCategoryId.value = null

					if (store.getters.companyList && store.getters.company) {
						var result = store.getters.companyList.find(item => item.companyId == store.getters.company.companyId)
						if (result) {
							todayImg.value = result.todayImg
			
							toShowDetail()
						}
						else {
							toGetUserInfor()
						}

					}
					else {
						toGetUserInfor()
					}
				}
				//如果不是文章返回的到文章列表 重置数据
		
					
			
			})
		onDeactivated	(() => {
			
			if (tab.value == 0 && aiCategoryId.value != null) {
				toDoArticleRecord(aiCategoryId.value, 2)
			}
			else
				toDoArticleRecord(articleId.value, 2)
		})
		onActivated(() => {

			fontSize.value = store.getters.fontSize
			toGetResize(fontSize.value, 2, aiContent.value)
			if (catalogList.value.length == 0) {
				if ($router.currentRoute.value.query.carticleId) {
					articleId.value = $router.currentRoute.value.query.carticleId
					if (store.getters.company) {
						todayImg.value = store.getters.company.todayImg
						toShowDetail()
					}
					else {
						toGetUserInfor()
					}
				}
			}
			else document.querySelector('.scrolldiv').scrollTop = scrollY.value
		})
		const articleId = ref('')

		const toShowDetail = () => {
			
			var height = document.getElementById('container').offsetHeight
			scrolldiv.value = { height: (height - 20) + 'px', overflow: 'auto' }
			reloadSpinning.value = true
			guestArticle({ id: articleId.value }).then(async (res) => {
				let cc = res.data.content;

				cc = cc.replace(/\&quot;/g, '"');
				var content = JSON.parse(cc);

				if (!(content instanceof Array)) {
					content = []
				}
				if (content.length == 0) {
					return;
				}
				//判断是否有ai日报
				var aiResult = content.find(item => item.daily_report_id != null)
				console.log(aiResult, 'xixi')
				if (aiResult != null) {
					aiCategoryId.value = aiResult.daily_report_id

					content = content.filter(item => item.daily_report_id == null)
					await guestArticle({ id: aiCategoryId.value }).then(async (res) => {
						aiContent.value = res.data.content

					})
				}

				// precontent内容
				precontent.value = content.length;
				let ids = [];
				for (let i = 0; i < content.length; i++) {
					let ct = content[i];
					ids.push(ct.id);
				}
				let readIds = [];
				await readList(ids).then(res => {
					readIds = res.data;
					// 设置二级标签
					const regex = /【.*?】/;
					var key = 1;
					var catalog = []
					content.forEach((item, index) => {
						let catalogItem = {};
						let orgin = item.title;
						let l = regex.exec(orgin);
						// l 是空或者索引不是第一个
						if (l == null || l.length == 0 || l.index != 0) {
							catalogItem["title"] = orgin;
						} else {
							let first = l[0];
							catalogItem["title"] = orgin.substring(first.length);
							catalogItem["secondaryArticleCategory"] = first.substring(1, first.length - 1);
						}
						catalogItem["articleCategoryId"] = item.articleCategoryId;
						catalogItem["articleCategory"] = item.articleCategory;
						catalogItem["introduction"] = item.introduction;
						catalogItem["id"] = item.id;
						catalogItem["key"] = key++;
						if (readIds.length > 0 && readIds.find((ii) => ii == item.id)) {
							catalogItem["read"] = true
						}
						else catalogItem["read"] = false
						//获取catalog对应的index
						var catalogIndex = catalog.length == 0 ? -1 : catalog.findIndex(item => item.articleCategoryId ? item.articleCategoryId == catalogItem["articleCategoryId"]
							: item.articleCategory == catalogItem["articleCategory"])
						if (catalogIndex == -1) {
							catalog.push({
								articleCategory: catalogItem["articleCategory"],
								articleCategoryId: catalogItem["articleCategoryId"],
								children: []
							})
							catalogIndex = catalog.length - 1
						}
						catalog[catalogIndex].children.push(catalogItem)
					})
					console.log(catalog, 'catalog')
					catalogList.value = createTitle(store.getters.company.companyId, catalog,'catalog')
					reloadSpinning.value = false
					if (aiCategoryId.value) {
						toDoArticleRecord(aiCategoryId.value, 0)
					}
					else
						toDoArticleRecord(articleId.value, 0)
					nextTick(() => {

						if (aiCategoryId.value) {
							$('.ai-category a').removeAttr('href');
							// console.log($('.ai-category').html(),'outerHTMLxixi')
							// if($('.ai-category')[0])
							// aiContent.value=$('.ai-category')[0].outerHTML;
						}
						setOffsetTop()
					})
				});
			})
		}
		const reloadSpinning = ref(false)
		const article = ref('')
		const scrolldiv = ref('')
		const catalogList = ref([])
		const precontent = ref(0)
		const todayImg = ref('')
		const originalContent = ref('')
		const toGetUserInfor = () => {

			getLoginUserInfo().then((res) => {
				store.dispatch('companyList', res.data.sysClient.companyVos[0])

				toShowDetail()
			})
		}
		const clickAticle = (val) => {
			if(val.articleCategoryId==216){
				router.push({ name: 'weeklyArticleDetail', query: { articleId: val.id } })
			}
			else if (val.productType == 5) {
				router.push({ name: 'catalogArticleDetail', query: { carticleId: val.id } })
			}
			else {
				router.push({ name: 'articleDetail', query: { articleId: val.id } })
			}
			var flag= false
			for(var i in  catalogList.value){
							for(var j in catalogList.value[i].children){
								   if(catalogList.value[i].children[j].id==val.id){
												 catalogList.value[i].children[j].read=true
													flag=true
													break
											}
							}
							if(flag) break
			}
	
		}
		const scrollY = ref(0)
		const fontSize = ref('')
		const aiContent = ref('')
		const tab = ref(0)
		watch(() => tab.value, (val) => {

			if (val == 0 && aiCategoryId.value != null) {

				nextTick(() => {
					$('.ai-category a').removeAttr('href');

				})
			}

		})
		const aiCategoryId = ref(null)
		const tabSrc = ref('https://enplus.oss-cn-guangzhou.aliyuncs.com/file/46a5d4af-ae6a-4f0e-9282-aebab4b6c347.png')
		const toTab = (index) => {
			var oldIndex = tab.value
			tab.value = index

			if (index == 0 && oldIndex == 1) {
				toDoArticleRecord(aiCategoryId.value, 0)
				toDoArticleRecord(articleId.value, 2)
			}
			else if (index == 1 && oldIndex == 0) {

				toDoArticleRecord(articleId.value, 0)
				toDoArticleRecord(aiCategoryId.value, 2)
			}


		}
		const linkList = ref([])
		const aiContentClick = (event) => {
			console.log(event, 'event')
			if (event.target.className == 'quote') {
				var list = []

				var eLinkList = event.target.attributes['data-href'].value.split("==")
				var eTitleList = event.target.attributes['data-title'].value.split("==")
				var eIndexList = event.target.attributes['data-index'].value.split("==")
				for (var i in eLinkList) {
					list.push({
						title: eTitleList[i],
						href: eLinkList[i],
						index: eIndexList[i]
					})
				}
				console.log(list, 'linkList')
				linkList.value = list
				linkArticle.value = {
					'display': 'block',
					'top': event.target.offsetTop + 'px',
					'index': 0
				}
				nextTick(() => {

					linkArticle.value.top = (event.target.offsetTop - $('.linkArticle').height() - 27) + 'px'
					linkArticle.value.index = 10
					// 创建一个选择器查询对象，.in(this)确保查询在当前页面的上下文中进行，而不是全局的上下文
					// const query = uni.createSelectorQuery().in(this);
					// var  superThis = this 
					// // boundingClientRect 会返回元素的边界信息（如宽度、高度、位置等）
					// query.select('#linkArticle').boundingClientRect(rect => {

					// 	superThis.linkArticle.top=(e.detail.y-rect.height-27)+'px'
					// 	superThis.linkArticle.index=10
					// 	}).exec();

				})

			} else linkArticle.value.display = 'none'

		}
		const linkArticle = ref({

			display: 'block',
			top: '0px',
			index: -10


		})



		const clickLinkArticle = () => {
			return
		}
		const clickLinkArticleItem = (item) => {
			console.log(item, 'clickLinkArticleItem')
			linkArticle.value.display = 'none'
			router.push({ name: 'articleDetail', query: { articleId: item.href } })

		}
		const categoryPageClick = () => {

			linkArticle.value.display = 'none'
		}
		const toGetResize = (val, oldVal, htmlContent) => {
			if (val == oldVal) {
				aiContent.value = htmlContent;
			}
			htmlContent = htmlContent.replace(/font-size:\d{1,20}px/g, function (param) {
				var result = param.substring(param.indexOf(':') + 1, param.indexOf('p'))
				return 'font-size:' + (Number(result) + (val - oldVal) * 2) + 'px'
			})
			aiContent.value = htmlContent;
		}
		const offsetTop=ref(0)
		const collapsedList=ref([])
		const toCollapsed=(val)=> {
				var index =collapsedList.value.indexOf(val)
				if (index > -1)
				collapsedList.value.splice(index, 1)
				else collapsedList.value.push(val)

			}
		const	isCollapsed=(val)=>  {
				var index = collapsedList.value.indexOf(val)
				return index == -1 ? true : false
		}
		const setOffsetTop=()=>{
			var element=document.getElementsByClassName('fontResize')

			offsetTop.value=element[0].clientHeight+'px'
		}
		return {
			setOffsetTop,
			offsetTop,
			collapsedList,
			toCollapsed,
			isCollapsed,
			
			originalContent,
			toGetResize,
			linkArticle,
			clickLinkArticle,
			clickLinkArticleItem,
			tabs: ['小Q日报', '文章列表'],
			linkList,
			tab,
			tabSrc,
			aiContent,
			aiCategoryId,
			aiContentClick,
			linkSrc: 'https://enplus.oss-cn-guangzhou.aliyuncs.com/file/ea4d857a-0283-42db-b265-92658fc03803.png',
			categoryPageClick,
			fontSize,
			scrollY,
			clickAticle,
			toGetUserInfor,
			todayImg,
			precontent,
			catalogList,
			scrolldiv,
			article,
			articleId,
			reloadSpinning,
			toTab
		}
	},
	beforeRouteLeave(to, from, next) {
		if (to.path == '/INT') {
			this.scrollY = 0
		}
		else
			//保存滚动条元素div的scrollTop值
			this.scrollY = document.querySelector('.scrolldiv').scrollTop
		next();
	},
}
</script>
<style lang="scss" scoped>
@import '../../assets/style.scss';

.ubutton-class {
	padding: 0 10px !important;
	border: none !important;
	cursor: pointer;

	.u-hairline-border::after {
		border: none !important;
	}
}

.introduce {
	color: #888e90;
	cursor: pointer;
	font-size: 15px;
	line-height: 22px;
	text-overflow: ellipsis;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 4;
	line-clamp: 4;
	-webkit-box-orient: vertical;
	padding: 0px 12px 0px 12px;
	text-align: justify;
}

.introduceSmall {
	font-size: 13px !important;
}

.introduceBig {
	font-size: 17px !important;
}

.inline-content {
	cursor: pointer;
}

.inline-content {
	a {
		color: rgba(0, 0, 0, 0.9);
	}

	.article-title-name {
		color: #009DA6;
		font-weight: bold;
		margin-right: 10upx;
	}
}

.inline-content:hover {
	a {
		color: #315efb !important;
	}

}
	.introduce:hover{
				color: #babcbc !important;

	}
.scrolldiv {
	justify-content: center;
	display: flex;
}

.catalog-article-detail {


	.home {
		margin-left: 24px;
		width: 48px;
		height: 48px;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;

		.home-img {
			width: 48px;
			height: 48px;
		}
	}

	.detail {
		padding: 20px 20px 80px;
		font-size: 24px;

		position: relative;

		.powerby {


			.powerby-image {
				width: 100%;
			}
		}

		.precontent.titleBig {
			font-size: 20px;
			line-height: 38px;
		}

		.article-title.titleBig {
			font-size: 20px !important;

			.inline-content {
				font-size: 18px;
				line-height: 38px;
			}
		}

		.article-title.titleSmall {
			font-size: 16px !important;

			.inline-content {
				font-size: 14px;
				line-height: 34px;
			}
		}

		.precontent.titleSmall {
			font-size: 16px;
			line-height: 34px;
		}

		.precontent {
			font-size: 18px;
			line-height: 36px;
			color: rgba(0, 0, 0, 0.5);
			margin: 32px 32px 16px 32px;

			.precontent-blue {
				color: #009DA6;
				font-weight: bold;
			}
		}

		.article-title {
			margin: 0px 32px 16px 32px;
			font-size: 18px;
			background-color: #ffffff;
			border-radius: 16px;

				border-bottom: 1px solid #f1f3f4;
				padding-bottom: 16px;
			.inline-title {
				padding: 24px 32px 24px 0px;
				display: flex;
			}

			.inline-title1 {
				padding: 24px 32px 0px 0px;
				display: flex;
			}

			.inline-img {
				width: 20px;
				height: 20px;
				margin-left: 6px;
			}

			.inline-content {
				line-height: 36px;
				color: rgba(0, 0, 0, 0.9);

				.article-category-name {
					margin-right: 10px;
					color: #009DA6;
					font-weight: bold;
				}

				.article-title-off {
					font-weight: normal;
					color: #a7adb0;
				}
			}

			.secondarySmall {
				font-size: 12px !important;
			}

			.secondaryBig {
				font-size: 16px !important;
			}

			.secondary {
				display: flex;
				justify-content: flex-end;
				margin-top: 8px;
				font-size: 14px;

				.bg-blue-category {
					background-color: #009DA6;
					border-radius: 16px 0px 16px 0px;
						max-width: 128px;
					height: 24px;

						background: linear-gradient(135deg, #009DA6 0%, #006DAA 100%);
					.text-s {
						color: #ffffff;
						text-align: center;
						line-height: 24px;
						font-weight: bold;
						padding-left: 16px;
							padding-right: 16px;
					}
				}
			}
		}
	}
}

.tabs {
	display: flex;
	width: 100%;
	padding: 32px;
	justify-content: space-between;
	cursor: pointer;

	.item {
		width: 45%;
		font-size: 17px;
		text-align: center;
		// line-height: 34px;
		height: 50px;
		border-radius: 5px;
		box-shadow: #959da533 0px 8px 24px;
		color: rgb(15, 193, 203);
		// border:1px solid #cfeef2;
		// background-color: rgb(245, 248, 253);
		background-color: rgb(245, 248, 253);
		letter-spacing: 1px;
		justify-content: center;
		display: flex;
		align-items: center;
		position: relative;

		.beta {
			background: #fff;
			color: #0496af;
			position: absolute;
			top: -10px;
			font-size: 14px;
			width: -moz-max-content;
			width: max-content;
			width: max-content;
			padding: 2px 8px;
			line-height: normal;
			right: -10px;
			border-radius: 5px;
			box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
			box-shadow: #959da533 0px 8px 24px;
		}

		img {
			width: 26px;
			height: 26px;
			margin-right: 2px;
		}
	}

	.item:hover {
		background: rgb(15, 193, 203);
		color: white;
		font-weight: 700;
		box-shadow: #959da533 0px 8px 24px;
	}


	.selected {

		background: rgb(15, 193, 203);
		color: white;

		font-weight: 700;
		box-shadow: #959da533 0px 8px 24px;
		// border-bottom: 4px solid;

	}
}

.linkArticle {
	display: none;
	background-color: white;

	position: absolute;
	color: #009DA6;
	left: 0;
	right: 0;
	margin: auto;

	width: 90%;
	padding: 10px 10px;
	border-radius: 10px;
	box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}


.linkItem {
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 15px;
	line-height: 30px;
	width: 95%;
	cursor: pointer
}

.linkItem:hover {
	color: #1890ff;
}
	.categorize {
		display: flex;
		justify-content: center;
		width: 100%;
		align-items: flex-end;
		margin: 15px 0px;



		.catalogTitle {
			font-size: 20px !important;
			letter-spacing: 1px;
			color: #009DA6;
			font-weight: bold;
			display: flex;
			align-items: flex-end;
		}

	}
	.categorize .titleBig{
		font-size: 22px !important;
		 line-height: 42px;
	}
	.categorize .titleSmall{
		font-size: 18px !important;
		 line-height: 36px;
	}
.catalog-content .article-title:last-of-type {
			/* 你的样式 */
			border-bottom: none;
		}

		.catalog-card {
			background: white;
			border-radius: 12px;
			box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
			border: 1px solid #e8ecf0;
			transition: all 0.3s ease;
			margin-bottom: 32px;

			.catalog-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 10px 14px;
				background: linear-gradient(135deg, #f8f9fa, #e9ecef);
				border-bottom: 1px solid #e8ecf0;
				cursor: pointer;
				transition: background 0.3s ease;
				position: relative;
				 &:hover{
				background: #f8f9fa;
				.toggle-button{
					    background-color: rgb(242 242 242);
    box-shadow: rgb(124 124 129 / 20%) 1px -1px 29px 10px;
				}
					}
					
			}

			.catalog-title {
				font-size: 20px;
				font-weight: 600;
				color: #2c3e50;
			}
	.catalog-title.titleSmall {
				font-size: 18px;

			}
			.catalog-title.titleBig {
				font-size: 22px;

			}
			.catalog-info {
				display: flex;
				align-items: center;
				gap: 12px;
			}

			.article-count {
				background: #009DA6;
				color: white;
				padding: 5px 10px;
				border-radius: 12px;
				font-size: 12px;
				font-weight: 500;
			}

			.toggle-button {
				background: transparent;
				border: 1px solid #dee2e6;
				border-radius: 50%;
				width: 32px;
				height: 32px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				transition: all 0.3s ease;
				color: #6c757d;
				font-size: 16px;
			}

			.iconClass {
				background: #009DA6 !important;
				color: white !important;
			}

			.catalog-content {
				overflow: hidden;
					transition: all 0.3s ease;
			}

			.collapsed {
				max-height: 0;

			}

		}

</style>
<style lang="less">
.ai-category {
	padding: 0px 32px 32px 32px;
	line-height: 36px !important;

	ul {
		list-style-type: disc;
		padding-left: 2em;
	}

	.quote {
		line-height: 12px !important;
	}

	ul ul {
		list-style-type: circle;
	}

	h2 {
		font-weight: bold;

		strong {
			font-weight: bold;
			color: #595959;
		}
	}


}
</style>
